"use client"

import { useTranslation } from "@/components/language-provider"
import { CONTACT } from "@/lib/constants"

export default function LegalClient() {
  const { t } = useTranslation()

  const sections = [
    { title: t("legal.privacyTitle"), body: t("legal.privacyBody") },
    { title: t("legal.termsTitle"), body: t("legal.termsBody") },
  ]

  return (
    <div data-testid="beauty-academy-legal-page">
      <section className="relative overflow-hidden border-b border-gray-100 py-14 md:py-20">
        <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_70%_50%_at_50%_-10%,rgba(168,85,247,0.08),transparent)]" />
        <div className="relative mx-auto max-w-3xl px-4 text-center">
          <h1 className="text-3xl font-extrabold tracking-tight text-gray-900 md:text-4xl">
            {t("legal.title")}
          </h1>
          <p className="mx-auto mt-4 max-w-2xl text-gray-600">{t("legal.intro")}</p>
        </div>
      </section>

      <div className="mx-auto max-w-3xl px-4 py-12">
        <div className="space-y-8">
          {sections.map((s) => (
            <section key={s.title}>
              <h2 className="text-lg font-bold text-gray-900">{s.title}</h2>
              <p className="mt-2 leading-relaxed text-gray-600">{s.body}</p>
            </section>
          ))}
          <section>
            <h2 className="text-lg font-bold text-gray-900">{t("legal.contactTitle")}</h2>
            <p className="mt-2 leading-relaxed text-gray-600">
              {t("legal.contactBody")}{" "}
              <a
                href={`mailto:${CONTACT.email}`}
                data-testid="beauty-academy-legal-contact-email"
                className="font-medium text-purple-600 hover:underline"
              >
                {CONTACT.email}
              </a>
            </p>
          </section>
        </div>
      </div>
    </div>
  )
}
